'use client';
import { useQuery } from '@apollo/client';
import { Case } from '@bybeam/platform-types';
import Loading from '@platform-ui-common/components/Loading/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import { FulfillmentContext } from '@platform-ui-common/hooks/contexts/useFulfillment.js';
import { ProgramContext } from '@platform-ui-common/hooks/contexts/useProgram.js';
import Color from '@platform-ui-common/utilities/Color.js';
import { useParams } from 'react-router';
import GetCaseFulfillments from '../../graphql/GetCaseFulfillments.graphql';
import { CaseContext } from '../../hooks/useCase.js';
import FulfillmentDetails from './components/FulfillmentDetails.js';

export default function FulfillmentDetailsComponent(): JSX.Element {
  const { caseId, fulfillmentId } = useParams<{ caseId: string }>();

  const { data, loading, error, refetch } = useQuery<{ cases: { cases: Case[] } }, { id: string }>(
    GetCaseFulfillments,
    { variables: { id: caseId } },
  );

  const case_ = data?.cases?.cases?.[0];
  const fulfillment = case_?.fulfillments?.find((fulfillment) => fulfillment.id === fulfillmentId);

  if (loading) return <Loading size="XXL" fullPage />;
  if (error || !fulfillment)
    return (
      <Typography variant="body" color={Color.Error}>
        Something went wrong
      </Typography>
    );

  return (
    <ProgramContext.Provider value={case_?.program?.id}>
      <CaseContext.Provider value={{ case_, refetch }}>
        <FulfillmentContext.Provider value={fulfillment}>
          <FulfillmentDetails />
        </FulfillmentContext.Provider>
      </CaseContext.Provider>
    </ProgramContext.Provider>
  );
}
